import { Box, BoxProps, Heading, Icon } from '@chakra-ui/react';
import { AiFillCheckCircle } from 'react-icons/ai';
import { useForeground } from 'src/modeAwareColors';
import { H2, P } from '../typography/typography';

function Pitch(props: BoxProps) {
  const fg = useForeground()
  return (
    <Box {...props}>
      <H2
        color={fg}
        maxW='420px'
        mb={8}
        fontWeight={600}
      >Projectlink is a professional network<br />for industry leaders</H2>
      <ul>
        <Box as='li' listStyleType='none'>
          <ListIcon />
          <ListItemText>
            Find organizations in your industry
          </ListItemText>
        </Box>
        <Box as='li' listStyleType='none'>
          <ListIcon />
          <ListItemText>
            Find active projects
          </ListItemText>
        </Box>
        <Box as='li' listStyleType='none'>
          <ListIcon />
          <ListItemText>
            Find suppliers
          </ListItemText>
        </Box>
        <Box as='li' listStyleType='none'>
          <ListIcon />
          <ListItemText>
            Connect with clients
          </ListItemText>
        </Box>
        <Box as='li' listStyleType='none'>
          <ListIcon />
          <ListItemText>
            Secure, private infrastructure
          </ListItemText>
        </Box>
      </ul>
    </Box>
  )
}

const ListItemText = props => (
  <P
    pl={3}
    d='inline'
    color='primary.accent4'
    {...props}
  />
)

const ListIcon = props => (
  <Icon
    as={AiFillCheckCircle}
    color='cyan.default'
  />
)

export default Pitch